import {
  type ClientInferResponseBody,
  type ClientInferRequest
} from "@ts-rest/core";
import { type CardIdentifier } from "@kanpla/api-contract";

import { client } from "../client";
import { type apiContract } from "../contract";
import { type Till } from "../tills/types";

export type SearchChildrenRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.getChildren
>;

export type SearchChildrenResponse = ClientInferResponseBody<
  typeof apiContract.v1.pos.tills.getChildren
>;

export async function getChildren(
  tillId: Till["id"],
  query: SearchChildrenRequest["query"]
) {
  const response = await client.v1.pos.tills.getChildren({
    params: { tillId },
    query
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

export async function updateChildCardIdentifier(
  tillId: string,
  childId: string,
  cardIdentifier: CardIdentifier
) {
  const response = await client.v1.pos.tills.updateUserCardIdentifier({
    params: { tillId },
    body: { childId, cardIdentifier }
  });

  if (response.status === 204) {
    return true;
  }

  throw response;
}
